(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"] && !window.DesignMode) return;
  try {
    

$(".more").click(function() {
  if ($(this).hasClass('toClose')) {
    var textmore = $(".text-more")[0];
    var textfull = $(".text-full")[0];
    textfull.style.height = "0px";
    textmore.style.height = textmore.scrollHeight + "px";
    var elem = $(".category-description-content-title")[0];
    elem.scrollIntoView();
    $(this).removeClass('toClose').text('Read more');
    
  } else {
    var textmore = $(".text-more")[0];
    var textfull = $(".text-full")[0];
    textmore.style.height = "0px";
    textfull.style.height = textfull.scrollHeight + "px";
    var elem = $(".category-description-content-title")[0];  
    elem.scrollIntoView();
    $(this).addClass('toClose').text('Show Less');
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh_header_ccm_mobile"]) return;
  try {
    
  $(".ccm-mobile-menu .close").on("click", function(e){
    e.preventDefault();
    $(".ccm-mobile-menu").toggleClass("active");
  })
  $(".ccm-mobile-menu .sub-menu-title").on("click", function(e){
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).closest(".sub-menu").find(".dropdown-wrap").slideToggle();
  })
  $(".ccm-mobile-menu .top-menu .menu-item > a").on("click", function(e){
    e.preventDefault();

    var tab_id = $(this).data("tab-id");
    
    // 
    $(".ccm-mobile-menu .top-menu .menu-item").removeClass("active");
    $(this).closest(".menu-item").addClass("active");

    // mobile menu
    $(".ccm-mobile-menu .menu .menu-item").removeClass("active");
    $(".ccm-mobile-menu .menu .menu-item[data-tab-id='"+tab_id+"']").addClass("active");

    // 
    // $(this).closest(".menu-item").toggleClass("active");
    // $(this).closest(".menu-item").find(".sub-menu").slideToggle();
  })

  } catch(e) { console.error(e); }
})();
})();
